export const convertStringToPlainText = (str: string) =>
  str
    .replace(/[^a-zA-Z ]/g, '')
    .replace(/\s/g, '')
    .toLowerCase();
